<template>
  <v-container grid-list-md>
    <v-row justify="space-around">
      <v-col md="6">
        <v-card>
          <v-card-title>Register New Client</v-card-title>
          <v-form ref="form" v-model="valid" class="mx-5">
            <v-row>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  v-model.trim="CustomerInfo.firstName"
                  validate-on-blur
                  :rules="[v => !!v || 'First Name is required']"
                  label="First Name"
                  color="success"
                  prepend-icon="mdi-account-edit"
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  v-model.trim="CustomerInfo.otherNames"
                  validate-on-blur
                  :rules="[v => !!v || 'other Name is required']"
                  label="Other Name"
                  color="success"
                  prepend-icon="mdi-account-edit"
                  required
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  v-model.number="CustomerInfo.Cusphone"
                  validate-on-blur
                  :rules="[v => !!v || 'Phone is required', minlength]"
                  label="Phone"
                  color="success"
                  type="number"
                  prepend-icon="mdi-cellphone-basic"
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="CustomerInfo.DOB"
                      label="Birthday date"
                      prepend-icon="mdi-calendar-search"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="CustomerInfo.DOB"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                    @change="save"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  v-model.trim="CustomerInfo.IDNomber"
                  validate-on-blur
                  :rules="[v => !!v || 'Passport or other ID is required']"
                  label="ID Number"
                  color="success"
                  prepend-icon="mdi-account-card-details-outline"
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-select
                  v-model.trim="CustomerInfo.cashType"
                  :items="GetCashTypes"
                  :rules="[v => !!v || 'Cash Type is required']"
                  label="Cash Type"
                  required
                  no-data-text="Refresh the page"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  v-model.number.trim="CustomerInfo.amount"
                  :rules="[v => !!v || 'Amount is required']"
                  name="OpenBalance"
                  label="Opening Balance"
                  type="number"
                  prepend-icon="mdi-account-cash"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <p class="mt-md-4 font-weight-black" v-if="CustomerInfo.amount">
                  {{ CustomerInfo.cashType | MoneySigns }}
                  {{ CustomerInfo.amount.toLocaleString() }}
                </p>
              </v-col>
            </v-row>
            <!-- <p>{{ CustomerInfo }}</p> -->
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn
                color="success"
                class="mb-5"
                width="200px"
                :loading="clicked"
                @click="OnSaveCustomer"
              >
                Register
                <v-icon right>mdi-content-save-all</v-icon>
              </v-btn>
            </v-card-actions>
          </v-form>
          <p v-if="ErrorMsg" class="red--text d-flex mt-2 justify-center">
            {{ ErrorMsg }}
          </p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      clicked: false,
      valid: true,
      date: null,
      menu: false,
      ErrorMsg: "",
      CustomerInfo: {
        firstName: null,
        otherNames: null,
        Cusphone: null,
        DOB: null,
        IDNomber: null,
        cashType: null,
        amount: null,
      },
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  computed: {
    ...mapGetters(["GetCashTypes"]),
  },
  methods: {
    isNumber(v) {
      if (v && isNaN(v)) return "Phone must be a number";
      else return false;
    },
    minlength(v) {
      // if (v && v.toString().length < 9)
      //   return "Phone length must be at least 9 number";
      // else return false;
      if (!v) return "Required phone";
      return (
        v.toString().length > 8 || "Phone length must be at least 9 number"
      );
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    OnSaveCustomer() {
      this.ErrorMsg = "";

      if (this.$refs.form.validate()) {
        this.clicked = true;
        this.CustomerInfo.date = this.Current().date;
        this.CustomerInfo.time = this.Current().time;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/customer",
            data: this.CustomerInfo,
          })
          .then(() => {
            this.$refs.form.reset();
            this.clicked = false;
            // this.CustomerInfo.firstName = null;
            // this.CustomerInfo.otherNames = null;
            // this.CustomerInfo.amount = null;

            // console.log(result);
          })
          .catch(err => {
            this.clicked = false;
            // console.log(err.response);
            if (err.response.status === 400) this.ErrorMsg = err.response.data;
            if (err.response.status === 409)
              this.ErrorMsg = this.CustomerInfo.Cusphone + " is registred";
          });
      }
    },
  },
  // created() {
  //   console.log(this.Current());
  //   console.log("Date");
  // }
};
</script>
